const  outformdata =[
      {
        inputdata: '',
        title: '经销商单据号',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'text',
        inputtype: 'input',
        width: '170px',
        lablewith: '95px',
        selcoms: false,
      },
      {
        inputdata: "",
        title: "出库日期",
        fontSize: "14px",
        color: "#333333",
        placeholder: "请输入",
        types: "",
        inputtype: "date",
        width: "140px",
        lablewith: '70px'
      },
      {
        inputdata: '',
        title: '付款方名称',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'text',
        inputtype: 'input',
        width: '160px',
        lablewith: '95px'
      },
     
      {
        inputdata: '',
        title: '产品线',
        fontSize: '14px',
        color: '#333333',
        placeholder: '全部',
        types: '',
        inputtype: 'select',
        width: '180px',
        lablewith: '95px',
        options: [],
      },
      {
        inputdata: "",
        title: "审核日期",
        fontSize: "14px",
        color: "#333333",
        placeholder: "请输入",
        types: "",
        inputtype: "date",
        width: "140px",
          lablewith: '70px'
      },
      {
        inputdata: '',
        title: '单据类型',
        fontSize: '14px',
        color: '#333333',
        placeholder: '全部',
        types: '',
        inputtype: 'select',
        width: '170px',
        lablewith: '95px',
        options: []
      },
      {
        inputdata: '',
        title: '产品型号',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'text',
        inputtype: 'input',
        width: '170px',
        lablewith: '95px'
      },
      {
        inputdata: '',
        title: '产品名称',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'text',
        inputtype: 'input',
        width: '300px',
        lablewith: '75px'
      },
      {
        inputdata: '',
        title: '批号',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'text',
        inputtype: 'input',
        width: '160px',
        lablewith: '95px'
      },
      {
        inputdata: '',
        title: '终端医院',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'text',
        inputtype: 'input',
        width: '180px',
        lablewith: '95px'
      },
]
export default outformdata